export default __webpack_public_path__ + "static/media/frame1-mobile.815db805.jpg";